import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { AppSettingsService } from './app-settings.service';

export function getSettings(appSettingsService: AppSettingsService) {
  return () => appSettingsService.getSettings();
}

@NgModule({
  imports: [HttpClientModule],
  providers: [
    { provide: APP_INITIALIZER, useFactory: getSettings, deps: [AppSettingsService], multi: true }
  ]
})
export class AppSettingsModule { }
